export const DEFAULT_RIGHTS = {
  canCreate: true,
  canRead: true,
  canUpdate: true,
  canDelete: true,
};

export const RIGHTS_FIELDS = [
  { key: 'canCreate', label: 'Create' },
  { key: 'canRead', label: 'Read' },
  { key: 'canUpdate', label: 'Update' },
  { key: 'canDelete', label: 'Delete' },
];
